<div class="col-xl">
  <div class="card-wrapper card-space">
    <div class="card card-bg">
      <div class="card-body">
        <div style="justify-content: center;">
          <div class="container">
            <div class="row" style="justify-content: center;">
              <div class="table-responsive" style="overflow-x: hidden">
                <table class="table table-striped">
                  <thead>
                  <tr>
                    <th scope="col" jhiTranslate="certificazioniEmesseTableTh.idRichiesta">Id Richiesta</th>
                    <th scope="col" jhiTranslate="certificazioniEmesseTableTh.data">Data</th>
                    <th scope="col" jhiTranslate="certificazioniEmesseTableTh.codFiscaleIntestatario">Cod. Fiscale Intestatario</th>
                    <th scope="col" jhiTranslate="certificazioniEmesseTableTh.cognomeIntestatario">Cognome Intestatario</th>
                    <th scope="col" jhiTranslate="certificazioniEmesseTableTh.nomeIntestatario">Nome Intestatario</th>
                    <th scope="col" jhiTranslate="certificazioniEmesseTableTh.descrizione">Descrizione</th>
                    <th scope="col" jhiTranslate="certificazioniEmesseTableTh.emesso">Emesso</th>
                    <th scope="col" jhiTranslate="certificazioniEmesseTableTh.scaricabile">Scaricabile</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Accedo 00001</td>
                    <td>01/01/23, 09:09</td>
                    <td>VRDMRI00A00B000C</td>
                    <td>ROSSI</td>
                    <td>MARIO</td>
                    <td>Estratto di nascita con Pat. e Mat.</td>
                    <td>Emesso</td>
                    <td style="text-align: center;">
                      <svg class="icon"><use href="./content/svg/sprites.svg#it-download"></use></svg>
                    </td>
                  </tr>
                  <tr>
                    <td>Accedo 00001</td>
                    <td>01/01/23, 09:09</td>
                    <td>VRDMRI00A00B000C</td>
                    <td>ROSSI</td>
                    <td>MARIO</td>
                    <td>Estratto di nascita con Pat. e Mat.</td>
                    <td>Emesso</td>
                    <td style="text-align: center;">
                      <svg class="icon"><use href="./content/svg/sprites.svg#it-download"></use></svg>
                    </td>
                  </tr>
                  <tr>
                    <td>Accedo 00001</td>
                    <td>01/01/23, 09:09</td>
                    <td>VRDMRI00A00B000C</td>
                    <td>ROSSI</td>
                    <td>MARIO</td>
                    <td>Estratto di nascita con Pat. e Mat.</td>
                    <td>Emesso</td>
                    <td style="text-align: center;">
                      <svg class="icon"><use href="./content/svg/sprites.svg#it-download"></use></svg>
                    </td>
                  </tr>
                  <tr>
                    <td>Accedo 00001</td>
                    <td>01/01/23, 09:09</td>
                    <td>VRDMRI00A00B000C</td>
                    <td>ROSSI</td>
                    <td>MARIO</td>
                    <td>Estratto di nascita con Pat. e Mat.</td>
                    <td>Emesso</td>
                    <td style="text-align: center;">
                      <svg class="icon"><use href="./content/svg/sprites.svg#it-download"></use></svg>
                    </td>
                  </tr>
                  <tr>
                    <td>Accedo 00001</td>
                    <td>01/01/23, 09:09</td>
                    <td>VRDMRI00A00B000C</td>
                    <td>ROSSI</td>
                    <td>MARIO</td>
                    <td>Estratto di nascita con Pat. e Mat.</td>
                    <td>Emesso</td>
                    <td style="text-align: center;">
                      <svg class="icon"><use href="./content/svg/sprites.svg#it-download"></use></svg>
                    </td>
                  </tr>
                  <tr>
                    <td>Accedo 00001</td>
                    <td>01/01/23, 09:09</td>
                    <td>VRDMRI00A00B000C</td>
                    <td>ROSSI</td>
                    <td>MARIO</td>
                    <td>Estratto di nascita con Pat. e Mat.</td>
                    <td>Emesso</td>
                    <td style="text-align: center;">
                      <svg class="icon"><use href="./content/svg/sprites.svg#it-download"></use></svg>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
